var locale = {
  locale: 'my_MM',
  today: 'ယနေ့',
  now: 'ယခု',
  backToToday: 'ယနေ့ မတိုင်ခင် သို့',
  ok: 'OK',
  clear: 'ရှင်းမည်',
  month: 'လ',
  year: 'နှစ်',
  timeSelect: 'အချိန်ကို ရွေး',
  dateSelect: 'နေ့ကို ရွေး',
  weekSelect: 'အပတ်ကို ရွေး',
  monthSelect: 'လကို ရွေး',
  yearSelect: 'နှစ်ကို ရွေး',
  decadeSelect: 'ဆယ်စုနှစ်ကို ရွေး',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'ယခင် လ (PageUp)',
  nextMonth: 'နောက် လ (PageDown)',
  previousYear: 'ယခင် နှစ် (Control + left)',
  nextYear: 'နောက် နှစ် (Control + right)',
  previousDecade: 'ယခင် ဆယ်စုနှစ်',
  nextDecade: 'နောက် ဆယ်စုနှစ်',
  previousCentury: 'ယခင် ရာစုနှစ်',
  nextCentury: 'နောက် ရာစုနှစ်'
};
export default locale;